import { createApp } from 'vue'
import App from './SocialTribe.vue'

createApp(App).mount('#app-social-tribe')
